<div class="modal-header">
    <h5 class="modal-title" id="emptyModalLabel">Xem Hợp Đồng</h5>
    <button type="button" class="btn-close" (click)="closeModal()" aria-label="Đóng">x</button>
  </div>
  <div class="modal-body">
    <!-- Tab Điều Hướng -->
    <ul class="nav nav-tabs" id="contractTabs" role="tablist">
        <li class="nav-item" role="presentation">
            <a class="nav-link active" id="details-tab" data-bs-toggle="tab" href="#details" role="tab" aria-controls="details" aria-selected="true">
                <i class="fas fa-file-contract me-1"></i> Chi tiết
            </a>
        </li>
        <li class="nav-item" role="presentation">
            <a class="nav-link" id="documents-tab" data-bs-toggle="tab" href="#documents" role="tab" aria-controls="documents" aria-selected="false">
                <i class="fas fa-folder-open me-1"></i> Tài liệu
            </a>
        </li>
    </ul>
    <!-- Nội dung Tab -->
    <div class="tab-content mt-3" id="contractTabsContent">
        <!-- Tab Chi tiết -->
        <div class="tab-pane fade show active" id="details" role="tabpanel" aria-labelledby="details-tab">
            <h5 class="card-title">Thông Tin Hợp Đồng</h5>
            <ul class="list-group list-group-flush">
                <li class="list-group-item"><strong>Số Hợp Đồng:</strong> {{ contract.contractNumber }}</li>
                <li class="list-group-item"><strong>Ngày Bắt Đầu:</strong> {{ contract.startDate }}</li>
                <li class="list-group-item"><strong>Ngày Kết Thúc:</strong> {{ contract.endDate }}</li>
                <li class="list-group-item"><strong>Nhà Cung Cấp:</strong> {{ contract.vendor.name }}</li>
            </ul>
            <h5 class="mt-4">Điều Khoản</h5>
            <p class="card-text">{{ contract.terms }}</p>
        </div>
        <!-- Tab Tài liệu -->
        <div class="tab-pane fade" id="documents" role="tabpanel" aria-labelledby="documents-tab">
            <div class="container mt-5">
                <h4 class="mb-4">Tài Liệu</h4>
                <div class="list-group">
                    <div class="list-group-item" *ngFor="let document of files">
                        <div class="d-flex justify-content-between align-items-center">
                            <span>{{ document.filename }}</span>
                            <button
                                class="btn btn-outline-primary" 
                                (click)="downloadFile(document.filename)">
                                <i class="fas fa-download me-1"></i> Tải Xuống
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Đóng</button>
  </div>
